import PropTypes from "prop-types";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { routePaths, strCode } from "../../../consts";
import { appUserService, t } from "../../../services";

import {
  DoubleButton,
  FlexContainers,
  Paragraph2,
  SearchInput,
  TextButton,
  WrapperContainer
} from "../../../components";

const AppsTableControls = ({ searchValue, setSearchValue, onCreateFromApp }) => {
  const history = useHistory();

  const onCreateFromScratch = () => {
    history.push(routePaths.CREATE_APP);
  };

  return (
    <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={12} width="100%">
      <WrapperContainer width="100%" maxWidth={329}>
        <SearchInput
          id="apps-search"
          value={searchValue}
          setValue={setSearchValue}
          placeholder={t(strCode.SEARCH_APPS_PLACEHOLDER)}
        />
      </WrapperContainer>

      {appUserService.isAdmin() && (
        <DoubleButton title={t(strCode.NEW_BTN)} onClick={onCreateFromScratch}>
          <TextButton onClick={onCreateFromApp}>
            <Paragraph2>{t(strCode.FROM_EXISTING_APP_TITLE)}</Paragraph2>
          </TextButton>

          <TextButton onClick={onCreateFromScratch}>
            <Paragraph2>{t(strCode.FROM_SCRATCH_TITLE)}</Paragraph2>
          </TextButton>
        </DoubleButton>
      )}
    </WrapperContainer>
  );
};

AppsTableControls.propTypes = {
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  onCreateFromApp: PropTypes.func.isRequired
};

export default AppsTableControls;
